export const LocationIcon = () => {
  return (
    <svg
      width="13"
      height="18"
      viewBox="0 0 13 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.49909 0.419556C9.89285 0.419556 12.6444 3.17044 12.6444 6.56421C12.6444 9.91392 10.281 14.4479 7.7593 17.2371C7.08642 17.984 5.91367 17.984 5.24015 17.2371C2.71909 14.4479 0.355713 9.91392 0.355713 6.56421C0.355713 3.17108 3.1066 0.419556 6.49973 0.419556H6.49909ZM6.49909 3.31919C8.29045 3.31919 9.7441 4.77284 9.7441 6.56357C9.7441 8.35494 8.29045 9.80859 6.49909 9.80859C4.70836 9.80859 3.25471 8.35494 3.25471 6.56357C3.25471 4.77284 4.70836 3.31919 6.49909 3.31919Z"
        fill="#568079"
      />
    </svg>
  );
};
